import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted } from "vue";
import E from "wangeditor";
export default defineComponent({
  components: {
    E: E
  },
  emits: ["update:puthtml", "update:putText", 'change'],
  setup: function setup(props, context) {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var Edi; //如果有值则回显

    onMounted(function () {
      var editor = new E("#content"); // 配置 server 接口地址

      editor.config.customUploadImg = function (resultFiles, insertImgFn) {
        resultFiles.forEach( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(v) {
            var formData, _yield$globalProperti, data;

            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    formData = new FormData();
                    formData.append("file", v);
                    _context.next = 4;
                    return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["upload"](formData);

                  case 4:
                    _yield$globalProperti = _context.sent;
                    data = _yield$globalProperti.data;
                    insertImgFn(process.env.VUE_APP_BASE_URL + data.fileName);

                  case 7:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      };

      editor.create();
      Edi = editor;

      editor.config.onchange = function (newHtml) {
        context.emit("update:puthtml", newHtml);
        context.emit("update:putText", editor.txt.text());
        context.emit("change");
      };

      editor.config.onchangeTimeout = 500;
    });

    function editfun(val) {
      Edi.txt.html(val);
    }

    return {
      editfun: editfun
    };
  }
});